import { t } from '@ctcells/i18n'

import { cx } from '../atoms/cx.ts'

import './figures.css'

/**
 * 비전 카메라(검사용) 진입 아이콘 — 와이어프레임 `vcamIcon()` 1669행 · `.vcam` CSS 823행.
 *
 * 모듈 그림에 **덧붙는 아이콘**이다. 누르면 포커스 뷰가 카메라 영상(`VisionFrame`)으로 바뀐다 —
 * 그림 탭의 「비전」과 **같은 동작이고 같은 상태를 본다**(`data-comp="vision"`).
 *
 * 🔴 **`VisionFrame` 과 다른 것이다.** 저쪽은 영상 프레임 본체이고 이것은 거기로 들어가는 문이다.
 *    영상 프레임은 카메라 화면이라 일부러 토큰 밖 고정색을 쓰지만, **이 아이콘은 UI 라서 토큰만 쓴다.**
 * 🔴 `div` 가 아니라 `button` 이다(§11-4-1). 와이어프레임 원본은 `div`+`data-comp` 위임이라
 *    키보드로 닿지 않았다 — 여기서 고친다.
 */
export interface VisionCameraButtonProps {
  /** 지금 비전이 골라져 있는가. 반전(검정 채움)으로 나가고 `aria-pressed` 로도 읽힌다 */
  selected?: boolean | undefined
  onClick?: (() => void) | undefined
  /**
   * 레일(3축 로봇) 오른쪽 가운데에 붙는 변형 — `.gantry>.vcam.corner` 827행.
   * 기본은 그림 오른쪽 위 모서리다.
   */
  corner?: boolean | undefined
}

export function VisionCameraButton({ selected = false, onClick, corner }: VisionCameraButtonProps) {
  return (
    <button
      aria-pressed={selected}
      className={cx('vcam', corner === true && 'vcam--corner', selected && 'vcam--on')}
      onClick={onClick}
      title={t('figure.visionCamera')}
      type="button"
    >
      <svg
        aria-hidden="true"
        className="vcam__icon"
        height={22}
        strokeLinejoin="round"
        strokeWidth={2.2}
        viewBox="0 0 24 24"
        width={22}
      >
        <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
        <circle cx={12} cy={13} r={3.5} />
      </svg>
      <small className="vcam__label">{t('figTab.vision')}</small>
    </button>
  )
}
